<template>
  <div id="alert">
    <v-container grid-list-xl fluid>
      <section style="margin: -30px">
        <v-parallax
          id="imgHeader"
          src="https://picsum.photos/800/600?image=2&blur"
          height="200"
        >
          <v-layout column align-center justify-center class="white--text">
            <h1 class="white--text mb-2 display-1 text-center">
              {{ this.course.course }}
            </h1>
            <div class="subheading mb-3 text-center">
              {{ this.course.description }}
            </div>
          </v-layout>
        </v-parallax>
      </section>
      <v-layout row>
        <v-flex lg12 sm12>
          <v-card flat> </v-card>
        </v-flex>
      </v-layout>
      <!-- complex chart -->
      <v-layout row wrap> </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import SessionAlertService from "@/services/sessionAlerts.service";

export default {
  components: {
    VWidget,
  },
  mounted() {
    // console.log('mounted')
  },
  data() {
    return {
      alert: null,
      loading: true,
    };
  },
  metaInfo() {
    return {
      title: "LS - Alerta de segurança",
      meta: [
        {
          vmid: "description",
          name: "description",
          content: "Este é um alerta de atividade suspeita na sua conta",
        },
      ],
    };
  },
  created() {
    this.loadCourse();
  },
  methods: {
    loadCourse() {
      SessionAlertService.getPendingAlerts().then((response) => {
        this.alert = response.data;
      });
    },
  },
};
</script>
